import * as React from 'react';

import { LocalizedComponentProps, withLocalization } from 'bernie-l10n';
import { ViewMedium, Viewport, ViewSmall } from 'bernie-view';

import { GalleryViewModel } from 'src/common/models';

import { UitkButtonSize, UitkSecondaryButton } from 'uitk-react-button';
import { UitkFigure, UitkFigureAspectRatioType, UitkImage } from 'uitk-react-images';
import { UitkIconSize } from 'uitk-react-icons';
import { UitkLayoutGrid, UitkLayoutGridItem } from 'uitk-react-layout-grid';

import { TabGroupContext } from 'src/common/components/common/tab-group';

const NUMBER_OF_MOSAIC_IMAGES = 3;

export interface GalleryMosaicProps extends LocalizedComponentProps {
  gallery?: GalleryViewModel;
}

@withLocalization
export class StaticGalleryMosaic extends React.Component<GalleryMosaicProps> {
  public constructor(props) {
    super(props);
  }

  public render() {
    const mosaicImages = this.props.gallery && this.props.gallery.images && this.props.gallery.images.slice(0, NUMBER_OF_MOSAIC_IMAGES);
    const UitkFigureComponent = (img, overlayTriggerBtn = undefined) => (
      <UitkFigure ratio={UitkFigureAspectRatioType.R16_9} data-stid="static-gallery-mosaic-img">
        <UitkImage src={img.src || undefined} placeholderImage={!img.src} overlayTrigger={overlayTriggerBtn} />
      </UitkFigure>
    );

    const overlayTrigger = tabContextData => {
      const callback = () => {
        const { changeTab, tabs } = tabContextData;
        const tabInfo = tabs.find(tab => tab.rfrr === 'Tab.Photos');
        if (tabInfo && tabInfo.label) {
          changeTab(tabInfo.label);
        }
      };

      return (
        <UitkSecondaryButton
          size={UitkButtonSize.SMALL}
          text={this.props.l10n.formatText('hotels.infosite.gallery.viewAll.title')}
          onClick={callback}
          icon={'apps'}
          iconSize={UitkIconSize.SMALL}
        />
      );
    };

    if (!mosaicImages) {
      return null;
    }

    return (
      <TabGroupContext.Consumer>
        {context => (
          <Viewport>
            <ViewSmall>{mosaicImages[0] && UitkFigureComponent(mosaicImages[0], overlayTrigger(context))}</ViewSmall>
            <ViewMedium>
              <UitkLayoutGrid columns={{ medium: 2, large: 3 }} rows={{ large: 2 }} space="two">
                {mosaicImages[0] && (
                  <UitkLayoutGridItem colSpan={{ medium: 2, large: 2 }} rowSpan={{ large: 2 }}>
                    {UitkFigureComponent(mosaicImages[0])}
                  </UitkLayoutGridItem>
                )}
                {mosaicImages[1] && (
                  <UitkLayoutGridItem rowSpan={{ large: 1 }} colSpan={{ medium: 1 }}>
                    {UitkFigureComponent(mosaicImages[1])}
                  </UitkLayoutGridItem>
                )}
                {mosaicImages[2] && (
                  <UitkLayoutGridItem rowSpan={{ large: 1 }} colSpan={{ medium: 1 }}>
                    {UitkFigureComponent(mosaicImages[2], overlayTrigger(context))}
                  </UitkLayoutGridItem>
                )}
              </UitkLayoutGrid>
            </ViewMedium>
          </Viewport>
        )}
      </TabGroupContext.Consumer>
    );
  }
}
